module.exports = __webpack_public_path__ + "img/product-placeholder-15.ef04b87.png";